{
  "name": "user-menu-web",
  "version": "0.2.0",
  "private": true,
  "engines": {
    "node": ">=20.x",
    "npm": ">=10.x"
  },
  "type": "module",
  "scripts": {
    "start": "vite",
    "build": "vite build && rimraf build/mockServiceWorker.js",
    "preview": "vite preview",
    "test": "tsc && vitest run",
    "test-ci": "npm run test -- --reporter=junit --outputFile.junit=./results/junit.xml",
    "test-dev": "vitest",
    "coverage": "vitest run --coverage",
    "ci-install": "PUPPETEER_SKIP_CHROMIUM_DOWNLOAD=true npm install",
    "lint": "biome check .",
    "lint-fix": "biome check --write .",
    "format-code": "biome format --write .",
    "format-code-on-commit": "npm run format-code && git add",
    "audit": "npm audit --registry https://registry.npmjs.org --parseable --omit=dev",
    "pull-translations": "phrase pull --access_token $PHRASEAPP_ACCESS_TOKEN",
    "push-translations": "phrase push --access_token $PHRASEAPP_ACCESS_TOKEN",
    "playwright-test": "playwright test",
    "playwright-open": "playwright test --ui",
    "msw-init": "msw init public --save=false",
    "playwright-install": "playwright install --with-deps chromium",
    "playwright-setup": "npm run msw-init && npm run playwright-install"
  },
  "dependencies": {
    "@reduxjs/toolkit": "2.12.0",
    "@rio-cloud/rio-session-expired-info": "2.0.0",
    "@rio-cloud/rio-uikit": "2.5.1",
    "@sentry/browser": "10.74.0",
    "iframe-resizer": "4.3.11",
    "lodash": "4.18.1",
    "oidc-client-ts": "3.5.0",
    "react": "18.3.1",
    "react-dom": "18.3.1",
    "react-intl": "7.1.14",
    "react-redux": "9.3.0"
  },
  "devDependencies": {
    "@biomejs/biome": "2.5.13",
    "@playwright/test": "1.63.0",
    "@rio-cloud/rio-license-checker": "1.2.5",
    "@rio-cloud/vite-plugin-frontend-license-check": "3.1.1",
    "@testing-library/dom": "10.4.2",
    "@testing-library/jest-dom": "7.0.1",
    "@testing-library/react": "16.3.3",
    "@testing-library/user-event": "14.6.7",
    "@types/lodash": "4.17.25",
    "@types/node": "24.13.4",
    "@types/react": "18.3.31",
    "@types/react-dom": "18.3.7",
    "@types/react-redux": "7.1.34",
    "@vitejs/plugin-react": "6.1.1",
    "events": "3.3.0",
    "jsdom": "30.0.1",
    "msw": "2.15.0",
    "rimraf": "6.1.3",
    "rollup-plugin-visualizer": "7.1.1",
    "typescript": "5.9.3",
    "vite": "8.3.0",
    "vitest": "5.0.1"
  },
  "msw": {
    "workerDirectory": "public"
  }
}
